import React, { useEffect } from "react";
// 引入样式文件
import "./main.css";
// 引入 AOS 动画库及其样式
import Aos from "aos";
import "aos/dist/aos.css";
// 引入 React Router 中的 Link 组件，用于页面跳转
import { Link } from "react-router-dom";

// 引入所需图标
import { HiOutlineLocationMarker, HiOutlineClipboardCheck } from "react-icons/hi";

// 导入图片资源，避免浏览器报错
import img1 from "../../Assets/Img/img(1).jpeg";
import img2 from "../../Assets/Img/img(2).jpeg";
import img3 from "../../Assets/Img/img(3).jpeg";
import img4 from "../../Assets/Img/img(4).jpeg";
import img5 from "../../Assets/Img/img(5).jpeg";
import img6 from "../../Assets/Img/img(6).jpeg";
import img7 from "../../Assets/Img/img(7).jpeg";
import img8 from "../../Assets/Img/img(8).jpeg";
import img9 from "../../Assets/Img/img(9).jpeg";
import img10 from "../../Assets/Img/img(10).jpeg";
import img11 from "../../Assets/Img/img(11).jpeg";
import img12 from "../../Assets/Img/img(12).jpeg";

// 引入 AuthContext 用于判断用户是否登录
import { useAuth } from "../../contexts/AuthContext";

// 数据数组，用于生成每个目的地卡片
// 目前只启用了 id:4, id:8, id:9, id:10, id:11, id:12 的数据对象
const Data = [
  {
    id: 4,
    imgSrc: img4,
    destTitle: "放飛一夏 - 歡樂美國夏令營",
    location: "美國 · 佛羅里達",
    grade: "12 至 19 歲",
    date: "七月",
    price: "$2990",
    description:
      "與美國在地學生共度私校夏令營，沉浸市民生活，參訪政府與文化機構；沐浴陽光，漫步沙灘，共賞壯麗夕陽；暢遊迪士尼、環球影城、樂高樂園與甘迺迪太空中心，樂享無限歡愉。",
  },
  {
    id: 8,
    imgSrc: img8,
    destTitle: "行者無疆 - 250年的美國獨立之路",
    location: "美國·東岸",
    grade: "12 至 19 歲",
    date: "七月",
    price: "$2990",
    description:
      "從五月花號到南北戰爭，從權力之心到紐約天際線，美國東岸見證了建國與發展的歷程。踏上美國人最熱愛的「Hit the Road」公路旅行，穿越建國獨立、奴隸逃亡與都市繁華的歷史足跡。2025年，更將特別前往華盛頓，親歷美國獨立戰爭250週年紀念慶典。",
  },
  {
    id: 9,
    imgSrc: img9,
    destTitle: "管中窺豹 - 德國高等教育與製造產業概覽",
    location: "德國",
    grade: "12 至 19 歲",
    date: "八月",
    price: "$2990",
    description:
      "獨具特色的高等教育、創新的雙軌制職業培訓，以及馬克斯·普朗克研究所等世界級研究機構，共同奠定德國傳奇製造業的基石，孕育福斯、寶馬、保時捷等全球知名品牌。課餘時光，將漫步於布拉格、柏林、德勒斯登，並探訪風光如畫的小鎮邁森，感受歐洲的歷史與浪漫。",
  },
  {
    id: 10,
    imgSrc: img10,
    destTitle: "世紀前沿 - 美國商業教育與企業",
    location: "美國 · 新英格蘭",
    grade: "14 至 21 歲",
    date: "六月",
    price: "$1990",
    description:
      "美國東海岸是國家誕生之地，匯聚最古老且頂尖的大學、研究機構，以及生物科學、醫藥研發、機器人技術、互聯網、金融保險等前沿產業。在這裡，歷史與創新交匯，你將親眼見證未來。",
  },
  {
    id: 11,
    imgSrc: img11,
    destTitle: "古今輝映 - 東亞的悠久與新興",
    location: "日本 · 台灣",
    grade: "12 至 23 歲",
    date: "八月",
    price: "$3990",
    description:
      "承襲盛唐遺風的世界文化遺產，孕育出風靡全球的二次元文化，日本如何成為動漫王國？而純樸而充滿活力的台灣，又是如何在全球半導體與電子製造業中獨占鰲頭？",
  },
  {
    id: 12,
    imgSrc: img12,
    destTitle: "浩瀚历史 - 中国名胜古迹精華瀏覽",
    location: "中國 · 北京、中原、西南、江浙滬",
    grade: "12 至 23 歲",
    date: "六月",
    price: "$3990",
    description:
      "踏上穿越歷史長河的壯麗旅程，探訪璀璨文化瑰寶：長城的雄偉、故宮的輝煌、祈年殿的莊嚴、雲崗石窟的精湛雕刻、應縣木塔的千年不倒、晉祠的古韻悠長；漫步少林寺與白馬寺，感受佛教文化；走進兵馬俑與三星堆，解讀古代文明；邂逅憨態可掬的大熊貓，流連九寨溝與桂林山水的絕美風光；最後沉浸於蘇州園林的詩意與上海外灘的摩登風情。",
  },
];

const Main = () => {
  // 使用 useEffect 初始化 AOS 動畫庫，設定動畫持續時間為 2000 毫秒
  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);

  // 從 AuthContext 中取得 currentUser 判斷是否已登录
  const { currentUser } = useAuth();

  // 点击“更多資訊”按钮时，若用户未登录，则阻止跳转并弹出提示
  const handleMoreInfo = (e, id) => {
    if (!currentUser) {
      e.preventDefault();
      alert("請先註冊 / 登入後才可看到更多資訊。");
    }
    if (id === 10) {
      alert("行程規劃中，請稍後再試")
       }
  };

  return (
    <section className="main container section">
      {/* 标题区域 */}
      <div className="secTitle">
        <h3 data-aos="fade-right" className="title">
          ⭐️ 推 薦 行 程 ⭐️
        </h3>
      </div>

      {/* 内容区域，使用 grid 布局展示所有目的地卡片 */}
      <div className="secContent grid">
        {Data.map(
          ({
            id,
            imgSrc,
            destTitle,
            location,
            grade,
            date,
            price,
            description,
          }) => (
            // 每个目的地卡片组件，使用 AOS 实现淡入效果
            <div key={id} data-aos="fade-up" className="singleDestination">
              {/* 图片部分 */}
              <div className="imageDiv">
                <img src={imgSrc} alt={destTitle} />
              </div>

              {/* 卡片信息部分 */}
              <div className="cardInfo">
                {/* 目的地标题 */}
                <h4 className="destTitle">{destTitle}</h4>
                {/* 位置及图标 */}
                <span className="continent flex">
                  <HiOutlineLocationMarker className="icon" />
                  <span className="name">{location}</span>
                </span>
                <br />

                {/* 费用及其他信息 */}
                <div className="fees flex">
                  <div className="grade">
                    年齡：{grade}
                    <br />
                    日期：{date}
                  </div>
                  <span className="grade">
                    {/* 这里可以根据实际情况显示价格或推荐等级 */}
                    <small>推薦：⭐️⭐️⭐️⭐️⭐️</small>
                  </span>
                </div>

                {/* 目的地描述 */}
                <div className="desc">
                  <p>{description}</p>
                </div>

                <br />
                {/* 更多資訊按钮 */}
                <div>
                  <button 
                  className="btn flex" 
                  style={{ float: "left" }}
                  onClick={(e) => handleMoreInfo(e, id)}
                  >
                    <Link to={`/${"signature" + id}`} target="_blank">
                      更多資訊
                    </Link>
                    <HiOutlineClipboardCheck className="icon" />
                  </button>
                </div>
              </div>
            </div>
          )
        )}
      </div>
    </section>
  );
};

export default Main;